import * as React from "react";
import { Col, Grid, Row, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Routine } from "redux-saga-routines";
import styled from "styled-components";
import { Form, Formik } from "formik";
import UnsavedCheck from "../../SaveNeeded/unsavedModal";
import { fetchTracking, saveTracking, updateDevicePositioning, updateAcceptLBS, saveDeviceSetting, getDeviceSetting } from "../Store/routines";
import {Action, ActionFunctionAny} from "redux-actions";
import TrackingOptions from "./trackingOpts";
import TrackingInfo from "./trackingInfo";
import {SettingDTO, TrackingSettings} from "../types";
import Footer from "../Components/Footer";
import withFormWrapper from "@Elements/Form/formWrapper";
import { AppState } from "@Safemate/Store/types";
import {Capabilities, DeviceSetting} from "@Safemate/Settings/Store/types";


const BorderCol = styled(Col)`
  @media (max-width: 992px) {
    margin-bottom: 15px;
  }
`;

export const TrackingButton = styled(Button)`
  margin: 5px;
`;

export const Info = styled.p`
  font-size: 14px;
  font-weight: normal;
`;

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 40px;
    width: 40px;
  }
`;

interface TrackingProps{
  deviId: number;
  deviceSnNum: string;
  fetchTracking: Routine<ActionFunctionAny<Action<any>>>;
  saveTracking: Routine<ActionFunctionAny<Action<any>>>;
  saveDeviceSetting: Routine<ActionFunctionAny<Action<any>>>;
  getDeviceSetting: Routine<ActionFunctionAny<Action<any>>>;
  updateDevicePositioning: Routine<ActionFunctionAny<Action<any>>>;
  updateAcceptLBS: Routine<ActionFunctionAny<Action<any>>>;
  settings: TrackingSettings;
  autoTracking: boolean;
  powerSaving: boolean;
  capabilities: Capabilities;
  trackingSetting: Record<string, SettingDTO>;
}

const Tracking = withFormWrapper<TrackingSettings, TrackingProps>(({deviId, fetchTracking, saveTracking, saveDeviceSetting, getDeviceSetting, settings, autoTracking, powerSaving, capabilities,trackingSetting, deviceSnNum}) => {

  React.useEffect(() => {
    fetchTracking(deviId);
  }, [deviId])

  React.useEffect(() => {
    if(deviceSnNum){
      getDeviceSetting(deviceSnNum);
    }
  }, [deviceSnNum])

  if(trackingSetting){

    return(
      <Formik
        onSubmit={(values) => {
          //updateDevicePositioning({deviceId: deviId, disablePositioning: values.disablePositioning});
          //updateAcceptLBS({deviceId: deviId, acceptLBS: values.acceptLBS});
          console.log("values: " + JSON.stringify(values, null,  4));
          saveDeviceSetting({
            deviceSnNum: deviceSnNum,
            deviceSetting: {
              settings: {
                tracking:{
                  ...values
                }
              }
            }
          })
        }}
        initialValues={{
          ...trackingSetting
        }}
        enableReinitialize
      >
        {({values, dirty}) =>
          <Form>
            <Grid fluid>
              <BorderCol sm={12} md={3}>
                <TrackingInfo/>
              </BorderCol>
              <Col sm={12} md={9}>
                <TrackingOptions capabilities={capabilities}/>
              </Col>
            </Grid>
            <UnsavedCheck/>
            <Footer
              settings={settings}
            />
          </Form>
        }
      </Formik>
    )
  } else {
    return null;
  }


})

const mapStateToProps = ({ settings: {tracking: {settings, autoTracking, powerSaving}, device:{deviceSetting, device:{deviceSerialNumber}}, initialization: {deviId}}}: AppState) => {
  return {
    deviId,
    settings,
    autoTracking,
    powerSaving,
    trackingSetting: deviceSetting && deviceSetting["settings"] ? deviceSetting["settings"]["tracking"] : undefined,
    deviceSnNum: deviceSerialNumber
  }
}

const mapDispatchToProps  = {
  fetchTracking,
  saveTracking,
  saveDeviceSetting,
  getDeviceSetting,
  updateDevicePositioning,
  updateAcceptLBS
};


export default connect(mapStateToProps, mapDispatchToProps)(Tracking);
